export default "__VITE_ASSET__Q3nwq4Ug__"